import { cn } from '@theprintbar/shared';
import { Suspense, lazy } from 'react';
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/free-mode';
import 'swiper/css/mousewheel';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import type { CarouselProps } from './CarouselBase';

const CarouselBase = lazy(() => import('./CarouselBase').then(module => ({ default: module.CarouselBase })));

export const Carousel = (props: CarouselProps) => {
	return (
		<Suspense
			fallback={
				// Load the slides and children as a static div to stop jumping
				<div className="swiper">
					<div className="swiper-wrapper">
						{props.slides.map((slide, index) =>
							slide ? (
								<div
									key={index}
									className={cn('swiper-slide', slide.containerProps?.className)}
									style={slide.containerProps?.style}
								>
									{slide.content}
								</div>
							) : null,
						)}
						{props.children}
					</div>
				</div>
			}
		>
			<CarouselBase {...props}>{props.children}</CarouselBase>
		</Suspense>
	);
};
